import styled, { css } from 'styled-components'
import { DefaultTheme } from 'styled-components'
import { ColorSchemeTypes } from '../../../types/ColorScheme'
import { Heading } from '../../atoms/Typography/Typography.styles'

interface LineProps {
  theme: DefaultTheme
}

interface FeaturesListsProps {
  theme: DefaultTheme
  colorScheme: ColorSchemeTypes
  withBackground?: boolean
}

export const Line = styled.div<LineProps>`
  width: 100%;
  padding-bottom: ${({ theme }) => theme.rem(24)};
  border-top: 1px solid;

  /* ${({ theme }) => theme.mediaQuery.lg(`
    padding-bottom: ${theme.rem(24)};
  `)} */
`

export const FeaturesLists = styled.div<FeaturesListsProps>`
  // padding-top: ${({ theme }) => theme.rem(24)};
  // padding-bottom: ${({ theme }) => theme.rem(24)};

  /* ${({ theme }) => theme.mediaQuery.lg(`
    padding-top: ${theme.rem(40)};
    padding-bottom: ${theme.rem(40)};
  `)} */

  ${({ theme, colorScheme }) => css`
    // background-color: ${theme.colorScheme[`${colorScheme}`].surface.inside};
  
    ${Line} {
      border-top-color: ${theme.colorScheme[`${colorScheme}`].surface.line};
    }
  `}

  ${Heading} {
    color: ${({ theme, withBackground, colorScheme }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : theme.colorScheme[`${colorScheme}`].surface.text.base.primary};
  }
`
